import { cva, type VariantProps } from 'class-variance-authority'

export { default as CupraButton } from './CupraButton.vue'

export const buttonVariants = cva(
    'uppercase inline-flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer border-1 border-cupra-white disabled:opacity-60',
    {
        variants: {
            variant: {
                primary: 'bg-cupra-white text-cupra-black hover:bg-cupra-white/90',
                secondary: 'bg-cupra-black text-cupra-white hover:bg-cupra-black/90',
                link: 'underline-offset-4 hover:underline',
            },
            size: {
                default: 'px-4 py-3 has-[>svg]:px-3',
                sm: 'gap-1.5 px-3 has-[>svg]:px-2.5',
                lg: 'px-6 has-[>svg]:px-4',
                icon: 'size-9',
            },
        },
        defaultVariants: {
            variant: 'primary',
            size: 'default',
        },
    },
)

export type ButtonVariants = VariantProps<typeof buttonVariants>
